module.exports = __webpack_public_path__ + "static/media/img_link_service_stop.9cb88ada.webp";